import { useState, useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';

const LOG_PREFIX = '[ws-locations-control][usePostalCode]';

const DDC =
	isBrowser && typeof window !== 'undefined' && window.DDC ? window.DDC : {};

const getCookie = (name) => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop().split(';').shift();
	} else {
		return '';
	}
};

export const isValidPostalCode = (code) => {
	if (!code || typeof code !== 'string') {
		return false;
	}
	const trimmedCode = code.trim();
	// US: 5 digits or ZIP+4
	const usPattern = /^\d{5}(-\d{4})?$/;
	// Canada: Letter-Digit-Letter space? Digit-Letter-Digit (excludes D, F, I, O, Q, U, W, Z in first position)
	const caPattern =
		/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ] ?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
	return usPattern.test(trimmedCode) || caPattern.test(trimmedCode);
};

export const usePostalCode = () => {
	const [postalCode, setPostalCode] = useState(null);

	useEffect(() => {
		if (!isBrowser) {
			logger.info(`${LOG_PREFIX} Not in browser, skipping`);
			return;
		}
		const geoZipFromUrl = DDC.getUrlParams().geoZip;
		const cookiePostalCode = getCookie('DDC.postalCode');
		if (geoZipFromUrl && isValidPostalCode(geoZipFromUrl.trim())) {
			// if we have a valid postal code in the URL, use that
			logger.info(
				`${LOG_PREFIX} Using geoZip from URL: ${geoZipFromUrl.trim()}`
			);
			setPostalCode(geoZipFromUrl.trim());
		} else if (cookiePostalCode && isValidPostalCode(cookiePostalCode)) {
			// if we have a valid postal code in the cookie, use that
			logger.info(
				`${LOG_PREFIX} Using postal code from cookie: ${cookiePostalCode}`
			);
			setPostalCode(cookiePostalCode);
		} else if (
			DDC.userLocation &&
			DDC.userLocation.userPostalCode &&
			isValidPostalCode(DDC.userLocation.userPostalCode)
		) {
			// if we have the user's postal code in the userLocation, we should use that
			// otherwise, use the postalCode from DDC
			logger.info(
				`${LOG_PREFIX} Using postal code from userLocation: ${DDC.userLocation.userPostalCode}`
			);
			setPostalCode(DDC.userLocation && DDC.userLocation.userPostalCode);
		} else {
			logger.info(`${LOG_PREFIX} Using default postal code: 10001`);
			setPostalCode('10001'); // default postal code
		}
	}, []);

	return postalCode;
};
